import { get, post } from './api-client';

export const catalogService = {
    getHomePageCategories: () => get('/catalog/homePageCategories'),

    getCategoryProductsBySlug: (categorySlug, body) => post(`/catalog/GetCategoryProductItemsBySlug/${categorySlug}`, body),

    //'q' it is not a misspell. nopCommerce only search if query string search keyword is set
    searchProducts: (data) => post('/catalog/customSearch?q', data),

    getBestSellers: () => get('/catalog/getBestSellers'),

    getCatalogSubCategories: (id) => get(`/catalog/getCatalogSubCategories/${id}`),

    getMenuLinks: () => get('/catalog/getMenuLinks'),

    quickSearchProduct: (term) => get('/catalog/quickSearch', { term }),

    getCategoryFilterBySlug: (categorySlug, body) => post(`/catalog/getCategoryFilterBySlug/${categorySlug}`, body),

    getSimpleSearchFilter: (data) => post('/catalog/getSimpleSearchFilter?q', data)
};